import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Define the shape of the state
export interface AppointmentState {
  data: any; // Replace `any` with a more specific type if possible
}

// Define the initial state
const initialState: AppointmentState = {
  data: null,
};

// Define the slice
const financialYearDataSlice = createSlice({
  name: 'appointmentSlice',
  initialState,
  reducers: {
    addFinancialData: (state, action: PayloadAction<any>) => {
      // Replace `any` with a more specific type if possible
      state.data = action.payload;
    },
  },
});

// Export the action creators and the reducer
export const { addFinancialData } = financialYearDataSlice.actions;
export default financialYearDataSlice.reducer;
